import React, { FunctionComponent } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { propOr } from 'ramda';
import withStyles from 'react-jss';

import { Theme } from 'config';
import { ClassProp } from 'helpers/types';

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  fieldValue: Date | string;
  record?: Record<string, any>;
  options?: Record<string, unknown>;
};

const styles = (theme: Theme) => ({
  icon: {
    display: 'inline !important',
    marginRight: '.875rem !important',
    cursor: 'pointer !important',
    color: `${theme.softGray} !important`,
  },
  message: {
    display: 'inline !important',
    marginLeft: '0.3125rem !important',
    color: `${theme.darkGray} !important`,
  },
});

const OfferDetailsBtn: FunctionComponent<Props> = ({ record, classes }) => {
  const match = useRouteMatch();
  const offerUuid = propOr('', 'offerUuid', record);

  return (
    <Link to={{ pathname: `${match.url}/offer/${offerUuid}` }}>
      <Icon name={'clone'} className={classes.icon}>
        <span className={classes.message}>Details</span>
      </Icon>
    </Link>
  );
};

export default withStyles(styles)(OfferDetailsBtn);
